<template>
  <v-dialog v-model="dialogDelete" max-width="290">
    <v-card class="card-rounded">
      <v-card-title class="headline">
        Atenção
      </v-card-title>
      <v-card-text>
        <div>
          {{ msg }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded text @click="cancel()">
          Não
        </v-btn>
        <v-btn rounded color="primary" text @click="remove(id)">
          Sim
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    dialogDelete: {
      type: Boolean,
      required: false,
    },
    msg: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  methods: {
    remove() {
      this.$emit("onConfirmDelete", this.id);
    },
    cancel() {
      this.$emit("onCancelDelete");
    },
  },
};
</script>
